// Create the mobile navigation elements by cloning the existing navigation element and changing an ID
var $appNav = $("#app-nav");
var $mobileNav = $("#mobile-nav");
$('#app-header').after($appNav.clone().attr('id', 'mobile-nav'));

// Remove elements from each type of nav depending on if they should exist there or not.
$appNav.find('.mobile-only').remove();
$("#mobile-nav").find('.desktop-only').remove();

// remove this button!
$('.contextual-navigation-show-button').hide();
// When the mobile menu is clicked, toggle some classes for visual representation.
$('#mobile-menu-button').on('click', function (e) {
    e.preventDefault();
    $("#mobile-nav").find('.desktop-only').remove();
    $("#mobile-nav").toggleClass('open');
    $('#app').toggleClass('nav-open');
    $('#mobile-menu-button').toggleClass('menu-open');

    if ($("#mobile-nav").hasClass('open')) {
        window.hideContextualNavigation();
        $('#contextual-navigation-trigger').hide();
//        $('.contextual-navigation-show-button').hide();
//        $('.contextual-navigation-hide-button').hide();
    } else {
        window.hideContextualNavigation();
        $('#contextual-navigation-trigger').show();
    }
});